module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "sidebar-right"
  }, [_c('div', {
    staticClass: "sidebar-right__inner"
  }, [(_vm.poemsSnap) ? _c('form', {
    staticClass: "search-box",
    style: ({
      borderLeftColor: _vm.theme.border2,
      borderBottomColor: _vm.theme.border,
      backgroundColor: _vm.theme.navbar
    }),
    on: {
      "click": _vm.focusSearch,
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitSearch($event)
      }
    }
  }, [_c('svg', {
    staticClass: "search-box__icon",
    attrs: {
      "fill": _vm.$store.state.searchFocused ? _vm.theme.accent : _vm.theme.icon,
      "height": "24",
      "width": "24"
    }
  }, [_c('use', {
    attrs: {
      "href": "#iconSearch"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    staticClass: "search-box__input",
    style: ({
      color: _vm.theme.text3
    }),
    attrs: {
      "id": "searchInput",
      "type": "search",
      "autocomplete": "off",
      "autocorrect": "off",
      "autocapitalize": "off",
      "spellcheck": "false",
      "placeholder": "Caută"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "focus": function($event) {
        return _vm.handleSearchFocus(true)
      },
      "blur": function($event) {
        return _vm.handleSearchFocus(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sidebar-right__main",
    style: ({
      backgroundColor: _vm.theme.background,
      borderColor: _vm.theme.border3
    })
  }, [(_vm.poemsSnap) ? _c('div', {
    staticClass: "sidebar-right__filters"
  }, [_c('div', {
    staticClass: "sidebar-right__filters-icon-wrapper",
    style: ({
      backgroundColor: _vm.theme.background,
      borderColor: !_vm.$store.state.filtersOpen ? '' : 'transparent'
    })
  }, [_c('svg', {
    staticClass: "icon icon-filters",
    attrs: {
      "fill": !_vm.$store.state.filtersOpen ? _vm.theme.icon2 : _vm.theme.accent,
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24"
    },
    on: {
      "click": _vm.toggleFilters
    }
  }, [_c('path', {
    attrs: {
      "d": "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "results-info"
  }, [_vm._v(_vm._s(_vm.resultsInfo))])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "filters"
    }
  }, [(_vm.$store.state.filtersOpen) ? _c('div', {
    staticClass: "sidebar-right__filter-wrapper",
    style: ({
      color: _vm.theme.text2
    })
  }, [_c('div', {
    staticClass: "sidebar-right__filter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedFilters),
      expression: "checkedFilters"
    }],
    attrs: {
      "type": "checkbox",
      "value": "checkboxTitle",
      "id": "checkboxTitle"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedFilters) ? _vm._i(_vm.checkedFilters, "checkboxTitle") > -1 : (_vm.checkedFilters)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checkedFilters,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "checkboxTitle",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedFilters = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkedFilters = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedFilters = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkboxTitle"
    },
    on: {
      "click": _vm.handleCheckTitle
    }
  }, [_c('svg', {
    staticClass: "icon icon-check",
    attrs: {
      "fill": _vm.theme.accent,
      "width": "24",
      "height": "24"
    }
  }, [_c('use', {
    staticClass: "off",
    attrs: {
      "href": "#iconCheck"
    }
  }), _vm._v(" "), _c('use', {
    staticClass: "on",
    attrs: {
      "href": "#iconCheckOn"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("În titlu")])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-right__filter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedFilters),
      expression: "checkedFilters"
    }],
    attrs: {
      "type": "checkbox",
      "value": "checkboxVerses",
      "id": "checkboxVerses"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedFilters) ? _vm._i(_vm.checkedFilters, "checkboxVerses") > -1 : (_vm.checkedFilters)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checkedFilters,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "checkboxVerses",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedFilters = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkedFilters = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedFilters = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkboxVerses"
    },
    on: {
      "click": _vm.handleCheckVerses
    }
  }, [_c('svg', {
    staticClass: "icon icon-check",
    attrs: {
      "fill": _vm.theme.accent,
      "width": "24",
      "height": "24"
    }
  }, [_c('use', {
    staticClass: "off",
    attrs: {
      "href": "#iconCheck"
    }
  }), _vm._v(" "), _c('use', {
    staticClass: "on",
    attrs: {
      "href": "#iconCheckOn"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("În versuri")])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-right__filter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedFilters),
      expression: "checkedFilters"
    }],
    attrs: {
      "type": "checkbox",
      "value": "checkboxWhole",
      "id": "checkboxWhole"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedFilters) ? _vm._i(_vm.checkedFilters, "checkboxWhole") > -1 : (_vm.checkedFilters)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checkedFilters,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "checkboxWhole",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedFilters = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkedFilters = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedFilters = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkboxWhole"
    }
  }, [_c('svg', {
    staticClass: "icon icon-check",
    attrs: {
      "fill": _vm.theme.accent,
      "width": "24",
      "height": "24"
    }
  }, [_c('use', {
    staticClass: "off",
    attrs: {
      "href": "#iconCheck"
    }
  }), _vm._v(" "), _c('use', {
    staticClass: "on",
    attrs: {
      "href": "#iconCheckOn"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Cuvinte întregi")])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-right__filter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedFilters),
      expression: "checkedFilters"
    }],
    attrs: {
      "type": "checkbox",
      "value": "checkboxCase",
      "id": "checkboxCase"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedFilters) ? _vm._i(_vm.checkedFilters, "checkboxCase") > -1 : (_vm.checkedFilters)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checkedFilters,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "checkboxCase",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedFilters = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkedFilters = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedFilters = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkboxCase"
    }
  }, [_c('svg', {
    staticClass: "icon icon-check",
    attrs: {
      "fill": _vm.theme.accent,
      "width": "24",
      "height": "24"
    }
  }, [_c('use', {
    staticClass: "off",
    attrs: {
      "href": "#iconCheck"
    }
  }), _vm._v(" "), _c('use', {
    staticClass: "on",
    attrs: {
      "href": "#iconCheckOn"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Ignoră majusculele")])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-right__filter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedFilters),
      expression: "checkedFilters"
    }],
    attrs: {
      "type": "checkbox",
      "value": "checkboxAccents",
      "id": "checkboxAccents"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedFilters) ? _vm._i(_vm.checkedFilters, "checkboxAccents") > -1 : (_vm.checkedFilters)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checkedFilters,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "checkboxAccents",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedFilters = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkedFilters = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedFilters = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkboxAccents"
    }
  }, [_c('svg', {
    staticClass: "icon icon-check",
    attrs: {
      "fill": _vm.theme.accent,
      "width": "24",
      "height": "24"
    }
  }, [_c('use', {
    staticClass: "off",
    attrs: {
      "href": "#iconCheck"
    }
  }), _vm._v(" "), _c('use', {
    staticClass: "on",
    attrs: {
      "href": "#iconCheckOn"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Ignoră diacriticele")])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-right__filter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedFilters),
      expression: "checkedFilters"
    }],
    attrs: {
      "type": "checkbox",
      "value": "checkboxPunctuation",
      "id": "checkboxPunctuation"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedFilters) ? _vm._i(_vm.checkedFilters, "checkboxPunctuation") > -1 : (_vm.checkedFilters)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checkedFilters,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "checkboxPunctuation",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedFilters = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkedFilters = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedFilters = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkboxPunctuation"
    }
  }, [_c('svg', {
    staticClass: "icon icon-check",
    attrs: {
      "fill": _vm.theme.accent,
      "width": "24",
      "height": "24"
    }
  }, [_c('use', {
    staticClass: "off",
    attrs: {
      "href": "#iconCheck"
    }
  }), _vm._v(" "), _c('use', {
    staticClass: "on",
    attrs: {
      "href": "#iconCheckOn"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Ignoră semnele de punctuație")])])])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sidebar-right__results",
    attrs: {
      "id": "sidebarRightResults"
    }
  }, _vm._l((_vm.results), function(result, index) {
    return _c('div', {
      key: index,
      staticClass: "result",
      attrs: {
        "id": ("res" + (result.nr))
      },
      on: {
        "click": function($event) {
          return _vm.handleResultClick($event, result.nr)
        }
      }
    }, [_c('span', {
      staticClass: "result__nr"
    }, [_vm._v(_vm._s(result.nr))]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "result__title",
      domProps: {
        "innerHTML": _vm._s(result.title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "result__verses"
    }, _vm._l((result.verses), function(verse, verseIndex) {
      return _c('div', {
        key: verseIndex,
        staticClass: "result__verse",
        domProps: {
          "innerHTML": _vm._s(verse)
        }
      })
    }), 0)])])
  }), 0), _vm._v(" "), (!_vm.poemsSnap) ? _c('loading', {
    staticClass: "loading",
    attrs: {
      "color": _vm.theme.accent
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7634b542","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarRight.vue
// module id = 132
// module chunks = 1